/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Section from '../Section';
import classes from './Sections.module.css';

const SECTIONS = [
  { name: 'Pending', key: 'pending' },
  { name: 'Coming Up', key: 'comingUp' },
  { name: 'In Progress', key: 'inProgress' },
  { name: 'Complete', key: 'complete' },
  { name: 'See Counter', key: 'seeCounter' },
];

const Sections = props => {
  const {
    showPopup,
    onFooterButtonPress,
    pendingCheckList,
    comingUpCheckList,
    inProgressCheckList,
    completeCheckList,
    seeCounterCheckList,
  } = props;

  const getCheckList = (section) => {
    switch (section.key) {
      case 'pending': return pendingCheckList;
      case 'comingUp': return comingUpCheckList;
      case 'inProgress': return inProgressCheckList;
      case 'complete': return completeCheckList;
      case 'seeCounter': return seeCounterCheckList;
      default: return [];
    }
  };

  return (
    <div className={classes.container}>
      {SECTIONS.map(section => {
        const checkList = getCheckList(section);
        return (
          <Section
            key={section.name}
            section={section}
            checkList={checkList}
            showPopup={showPopup}
            onFooterButtonPress={onFooterButtonPress}
            count={checkList.length}
          />
        )
      })}
    </div>
  )
};

export default Sections;

Sections.propTypes = {
  showPopup: PropTypes.func,
  onFooterButtonPress: PropTypes.func,
  pendingCheckList: PropTypes.array,
  comingUpCheckList: PropTypes.array,
  inProgressCheckList: PropTypes.array,
  completeCheckList: PropTypes.array,
  seeCounterCheckList: PropTypes.array,
};

Sections.defaultProps = {
  showPopup: () => { },
  onFooterButtonPress: () => { },
  pendingCheckList: [],
  comingUpCheckList: [],
  inProgressCheckList: [],
  completeCheckList: [],
  seeCounterCheckList: [],
};
